export default {
  NewAntrag: '/antrag/new/',
  GetAntrag: '/antrag/select_by_token/',
  GetConfig: '/antrag/config/',
  Sign: '/antrag/sign/',
  SaveError: '/jslog/'
}
